module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/notification-components/popup-notification-list/popup-notification-list.component.css
// module id = ./src/app/notification-components/popup-notification-list/popup-notification-list.component.css
// module chunks = main